import { useEffect } from "react";
import { pageview, button, link } from "@qoohoo/common/constants/analytics";
import toast from "react-hot-toast";
import * as Track from "@qoohoo/common/utils/analytics/track";
import { checkIfExistingMemberOfChannel } from "./JoinTelegramModal";
import CopyToClipboard from "react-copy-to-clipboard";
import {openInNewTab} from "@qoohoo/common/utils/url";
import Spinner from "@qoohoo/common/library/loader/Spinner";

export default function WhatsappThankYouModal({
  channelDetails,
  userChannelDetail, 
  isLoading,
  closeModal,
  customSettings
}) {
  const modal_name = "thank_you_modal";
  const trackDetails = {
    current_screen: pageview.channel_details,
    modal_name,
    is_paid: true,
    uid: channelDetails.uid,
    name: channelDetails.name,
    type: channelDetails.type,
    recurring_type: channelDetails?.plans?.[0]?.plan_type,
    "creator.uid": channelDetails.creator.uid,
    "creator.full_name": channelDetails.creator.fullname,
    "creator.username": channelDetails.creator.username,
    is_whatsapp: true,
  };

  function handleCloseModal() {
    closeModal();

    Track.buttonClick(button.thank_you, trackDetails);
  }

  function handleJoinWhatsappButtonClick() {
    window.open(userChannelDetail.whatsapp?.invite_link, "_blank");
    Track.linkClick(link.join_on_whatsapp_link, trackDetails);
  }

  useEffect(() => {
    Track.customEvent(modal_name, {
      actionType: "modal_open",
      label: modal_name,
      ...trackDetails,
    });

    if (customSettings?.redirection_on_success) {
      openInNewTab(customSettings.redirection_on_success, 1250);
    }
  }, []);

  let heading = "Thank you...", content, actionButton;

   if (isLoading) {
    content = (
      <div>
        Please wait...
        <div className="mt-8 flex items-center justify-center">
          <Spinner size="md" />
        </div>
      </div>
    )
  } else {
    const isExistingMemberOfChannel = checkIfExistingMemberOfChannel(userChannelDetail.membership_period_start);

    if (!isExistingMemberOfChannel) {
      content = "Your payment is successful, join on WhatsApp from here.";

      actionButton = (
        <div className="relative px-5 sm:px-0 py-3 sm:py-0 bg-transparent text-center mt-6 z-[1]">
          <button
            className="py-[14px] relative mb-3 sm:mb-0 w-full font-bold sm:w-80 bg-[#128C7E] rounded-full outline-none focus:outline-none"
            onClick={handleJoinWhatsappButtonClick}
          >
            Join on WhatsApp
          </button>
          <CopyToClipboard
            text={userChannelDetail.whatsapp?.invite_link}
            onCopy={() => {
              toast.success("Sharable link copied!");

              Track.buttonClick(button.copy_link, {
                ...trackDetails,
                link: userChannelDetail.whatsapp?.invite_link,
              });
            }}
          >
            <div className="mx-auto mt-6 cursor-pointer flex justify-center items-center hover:opacity-90">
              <span className="leading-[150%px] font-semibold text-[#58A6EE]">
                Copy invite link
              </span>
              <img
                src="/assets/icons/link-blue.svg"
                alt=""
                className="ml-2.5"
              />
            </div>
          </CopyToClipboard>
        </div>
      );

    } else if (isExistingMemberOfChannel) {
      heading = 'Congratulations!'
      content = 'Your membership is renewed 🎉';
      actionButton = (
        <button
          className="py-[14px] relative max-w-[136px] mt-6 mb-3 sm:mb-0 w-full font-bold sm:w-80 bg-[#128C7E] rounded-full outline-none focus:outline-none"
          onClick={handleCloseModal}
        >
          Ok, thanks
        </button>
      );
    } 
  }

  const onPaymentSuccessRedirection = customSettings?.redirection_on_success && (
    <p className="my-6 text-white text-base font-bold">
      Redirecting...
    </p>
  );

  return (
    <>
      <div className="mt-2 text-4xl leading-8 font-bold dark:text-[#16191B]">{heading}</div>
      <div className="text-base leading-[150%] font-light text-[#F0F0F0] mt-5 dark:text-[#16191B]">
        {content}
        {onPaymentSuccessRedirection}
      </div>
      {actionButton}
    </>
  );
}
